const getQuestionsCountFromLoi = (loi) => {
  if (!loi) return 0;
  const matches = String(loi).match(/\d+/g);
  if (!matches || matches.length === 0) return 0;
  return parseInt(matches[matches.length - 1], 10) || 0;
};

export const getTranslationManualBaseFee = ({ target } = {}) => {
  const questionsCount = getQuestionsCountFromLoi(target?.loi);
  return questionsCount > 0 ? questionsCount * 10 : 150;
};
